import styled from 'styled-components/macro';

import { palette, classes } from '@mirinae/react-ui';

const PopupTitle = styled.div`
    display: flex;
    align-items: center;
    height: 59px;
    margin: -20px -20px 0;
    padding: 20px;

    .${classes.desktop} & {
        cursor: move;
    }

    svg {
        margin-right: 5px;
    }
    strong {
        font-weight: 800;
        .${classes.desktop} & {
            font-size: 15px;
        }
        .${classes.mobile} & {
            font-size: 18px;
        }
    }
    span {
        margin-left: 5px;
        margin-top: 3px;
        color: ${palette.point.gray};
        font-size: 10px;
    }
`;

export default PopupTitle;